import theme from 'shared/assets/style/theme';
import Utils from 'shared/utils/index';
import { height as NavHeight } from 'shared/components/NavigationBar/sizes';

const ScrollBar = {
  backgroundColor: theme.palette.primary[10],
  cursor: 'pointer',
  width: '0.5rem',
  borderRadius: '8px',
  position: 'relative',
};

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

const defaultTheme = {
  //TODO: Refactor ScrollBar styles
  ScrollBar,
  LimitedTimeOffer: {
    LTOWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      height: '88%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    MainContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '70%',
      marginBottom: '0.5%',
      justifyContent: 'center',
      alignItems: 'center',
      lineHeight: 1.2,
      fontWeight: 600,
      height: '25%',
    },
    BannerContainer: {
      marginBottom: 0,
      fontWeight: '600',
      marginLeft: '-3%',
    },
    CoinIcon: {
      width: '12%',
      alignSelf: 'center',
      marginRight: '3%',
      marginTop: '0.5%',
    },
    StarIcon: {
      width: '9%',
      alignSelf: 'center',
      marginTop: '0.6%',
    },
    BuyButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    BuyButton: {
      position: 'absolute',
      bottom: '7%',
      transform: 'translateX(-10px)',
    },
    BuyButtonImageStyle: {
      width: windowHeight > 900 && windowWidth < 1300 ? '18vh' : '24vh',
    },
    BuyButtonTextStyle: {
      fontSize: '2.5em'
    }
  },
  NavigationBar: {
    LoyaltyCurrencyWrapperStyle: {
      position: 'absolute',
      right: windowWidth < 1300 ? 'calc(50% - 185px)' : 'calc(50% - 205px)',
    },
    LoyaltyCurrencyWrapperStyleWithoutCard: {
      position: 'absolute',
      right: 'calc(50% - 205px)',
    },
    LoyaltyCurrencyIconStyle: {
      height: 50,
      width: 50,
      top: -12,
      left: -5,
    },
    TopBar: {
      height: '5rem',
    },
    BarSection: {
      width: '100%',
      paddingBottom: 0,
      maxWidth: Utils.ieVersion() !== 0 ? 1430 : 1440,
      display: 'flex',
    },
    MiddleSection: {
      position: 'relative',
      fontWeight: 700,
      width: 344,
    },
    BarLineAnimation: {
      top: windowWidth < 2000 ? 0 : 1,
    },
    LevelBarAnimation: {
      width: '200%',
      height: '12rem',
    }
  },
  Tier: {
    Card: {
      height: 70,
      width: 95,
      position: 'absolute',
      cursor: 'pointer',
      pointerEvents: 'auto',
    },
    TierWrapper: {
      marginRight: windowWidth < 1400 ? '72px !important' : '103px !important',
    },
    CardAnimation: {
      height: 123,
      width: 150,
      left: -40,
      top: -30,
      zIndex: 10,
    },
  },
  OutOfCoin: {
    QuickBuyOfferDetails: {
      padding: ' 0 10px',
      position: 'absolute',
      bottom: '14%',
      left: 0,
      width: '100%',
      textAlign: 'center',
      boxSizing: 'border-box',
    },
  },
  Settings: {
    HeaderImage: {
      height: '3.7rem',
      width: '100%',
      objectFit: 'contain',
      zIndex: 11,
      position: 'absolute',
      top: 0,
      left: 0,
    },
    HeaderContent: {
      width: ' 100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 5vmin',
    },
    BackArrowContainer: {
      cursor: 'pointer',
      zIndex: 100,
      position: 'absolute',
      height: '2.3rem',
      width: '1.2rem',
      top: '1rem',
      left: '2rem',
    },
    BackgroundLightDivider: {
      backgroundImage: 'none',
    },
    TitleMargin: {
      marginBottom: '0',
    },
    TitleShadow: {
      display: 'flex',
    },
  },
  OfferDetail: {
    RewardCenterPurchaseResponseHeader: {
      fontSize: '2em',
      textTransform: 'uppercase',
      height: '14%',
      marginTop: '0.2em',
    },
    RewardCenterPurchaseResponseMessage: {
      marginTop: '1em',
      fontSize: '1.4em',
      height: '18%',
    },
    ExclamationIcon: {
      width: 160,
      height: '100%',
    },
  },
  Messages: {
    ScrollBar,
    HeaderContainer: {
      height: '4rem',
    },
    HeaderTitleContainer: {
      position: 'absolute',
      width: '100%',
    },
    HeaderTitle: {
      position: 'absolute',
      width: '100%',
      textAlign: 'center',
      fontSize: '28px',
      lineHeight: '54px',
      fontWeight: 600,
    },
  },
  LinkAccountForm: {
    HeaderImage: {
      height: '3.7rem',
      width: '100%',
      objectFit: 'contain',
      zIndex: 11,
      position: 'absolute',
      top: 0,
      left: 0,
    },
    HeaderTitle: {
      display: 'flex',
      fontSize: '1.9rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '1px',
      padding: 0,
      margin: 0,
      justifyContent: 'center',
      lineHeight: '3.7rem',
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.5)',
    },
    FormContainer: {
      margin: 20,
      maxHeight: '70vh',
    },
  },
  RegisterRewardCard: {
    HeaderImage: {
      height: '3.7rem',
      width: '100%',
      objectFit: 'contain',
      zIndex: 11,
      position: 'absolute',
      top: 0,
      left: 0,
    },
    HeaderTitle: {
      display: 'flex',
      fontSize: '1.9rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '1px',
      padding: 0,
      margin: 0,
      justifyContent: 'center',
      lineHeight: '3.7rem',
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.5)',
    },
    FormDescription: {
      textAlign: 'center',
    },
  },
  BonusLinkMessage: {
    PromoImage: {
      width: '100%',
      textAlign: 'center',
      paddingTop: '357px',
      position: 'absolute',
    },
    BonusLinkButton: {
      position: 'absolute',
      width: '100%',
      fontSize: '25px',
      lineHeight: '56px',
      fontWeight: 600,
      textShadow: `1px 1px 0px ${theme.palette.secondary[10]}, 1px -1px 0px ${theme.palette.secondary[10]}, -1px 1px 0px ${theme.palette.secondary[10]}, -1px -1px 0px ${theme.palette.secondary[10]}`,
    },
  },
  DailySpin: {
    DailyBonusHeader: {
      width: '100%',
      top: '95%',
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    BottomBar: {
      width: '100%',
      height: '22%',
    },
    BottomBarContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '1rem 0',
      width: '80%',
      height: '100%',
      maxHeight: windowWidth < 1800 ? 170 : 200,
    },
    BottomBarBackgroundWrapperImage: {
      width: '100%',
      height: '100%',
    },
    WheelItems: {
      fontSize: '2.3rem',
    },
    StreakDaysRowNumber: {
      paddingRight: 1,
      paddingBottom: 1,
    },
    StreakDaysRowValues: {
      marginTop: 0,
      lineHeight: 'inherit',
    },
    MilestoneCoinsValue: {
      marginBottom: 10,
    },
    MilestoneLoyaltyValue: {
      marginBottom: 0,
    },
    MilestoneCircleValue: {
      marginTop: 3,
    },
    BottomRightCoinImage: {
      marginBottom: 0,
    },
  },
  PurchaseFlow: {
    CreditCardDetails: {
      display: 'flex',
    },
  },
  CoinItem: {
    CoinAmount: {
      fontSize: '4vmin',
      fontWeight: 600,
    },
    Extra: {
      fontSize: '1.5vmin',
      marginTop: '1vmin',
      fontWeight: 600,
    },
  },
  ShopScreen: {
    top: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    left: '0px',
    position: 'absolute',
    width: '100%',
    height: '99%',

    ShopTitle: {
      color: theme.palette.common[15],
      fontSize: '32pt',
      fontWeight: 700,
      textAlign: 'center',
    },

    PurchaseTitle: {
      color: theme.palette.common[15],
      fontSize: '28pt',
      fontWeight: 700,
    },

    Spacer: {
      margin: '0.5rem',
    },

    SaleTimer: {
      position: 'absolute',
      top: '10%',
      right: '5%',
      width: '24%',
      height: '11%',
    },

    ShopContainer: {
      flex: 1,
      margin: '1rem',
      marginTop: '0rem',
      marginBottom: '0rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'stretch',

      ShopHeader: {
        display: 'flex',
        marginTop: '6vmin',
        height: '2rem',
      },

      PackagesContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'stretch',
        padding: '6% 5.5rem 0.4rem',

        TabButtonsContainer: {
          position: 'relative',
          zIndex: 1000,
          display: 'flex',
          top: '14%',
          height: '18%',
          marginTop: '-9.5%',

          TabButton: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            border: 'none',
            boxShadow: 'none',
            cursor: 'pointer',
            outline: 'none',
            width: '50%',
          },
        },

        CoinItem: {
          margin: '0.4rem',
          height: '3.3rem',
          borderRadius: '1rem',
          objectFit: 'stretch',
        },

        InnerItem: {
          color: theme.palette.common[16],
          display: 'flex',
          justifyContent: 'stretch',
          alignItems: 'center',

          Stack: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'center',
            padding: '4px 0',
            lineHeight: '0.8',
          },
        },
      },
    },
  },
  MessageDetails: {
    ScrollBar,
    MessageTitle: {
      fontSize: '1.5rem',
      fontWeight: 600,
      textAlign: 'center',
    },
  },
  HistoryList: {
    ScrollBar,
  },
  OfferList: {
    ScrollBar,
  },
  LinkAccount: {
    Description: {
      width: '100%',
      padding: '0 15%',
      fontSize: '12px',
    },
    LinkAccountContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    LinkAccountTitle: {
      fontSize: '1.5rem',
      textTransform: 'uppercase',
      textAlign: 'center',
      fontWeight: 700,
      margin: '0.2em auto',
    },
    AvailableCards: {
      height: '200px',
      display: 'flex',
      flexDirection: 'row',
      margin: '1.5rem 1rem',
    },
    LinkAccountButton: {
      position: 'relative',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
    },
    LightDividerUp: {
      display: 'none',
      width: '100%',
    },
    LightDividerDown: {
      display: 'none',
      width: '100%',
      transform: 'rotate(180deg)',
    },
  },
  VIPItem: {
    LogoImage: {
      display: 'none',
    },
    DurationFriendlyFull: {
      fontSize: '1.7rem',
      lineHeight: 1,
      paddingTop: '44%',
    },
  },
  FormButton: {
    LinkBtn: {
      backgroundImage: `url(${require(asset`RoundedRect_Pink@2x.png`)}`,
      cursor: 'pointer',
      fontSize: '1.7rem',
      fontWeight: '600',
      width: 181,
      height: 59,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      margin: '0 auto',
      marginTop: '20px',
      marginBottom: '10px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  FormFooter: {
    TermsLink: {
      textDecoration: 'underline',
      fontWeight: 'bold',
      color: theme.palette.primary[9],
      cursor: 'pointer',
    },
  },
  MessagesHeader: {
    Image: {
      position: 'absolute',
      top: '-1px',
      left: '-1px',
      height: '3.7rem',
      width: '100%',
      backgroundSize: 'calc(100% + 2px) 100%',
      backgroundImage: `url(${require(asset`Full_Modal_Header@3x.png`)}`,
    },
  },
  RewardHome: {
    RewardImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: '10px',
      backgroundSize: 'cover',
      pointerEvents: 'all',
      cursor: 'pointer',
    },
    RewardHoverOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: '10px',
      transition: '0.1s',
    },
  },
  RewardListItem: {
    RewardImagePlaceholderContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: '10px',
      backgroundSize: 'cover',
    },
    RewardHoverOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: '10px',
      transition: '0.1s',
    },
    OfferCost: {
      position: 'relative',
      padding: '0.5em 0',
      textAlign: 'center',
      flex: 0,
      top: '-25.5%',
    },
    OfferName: {
      color: theme.palette.common[1],
      top: windowWidth < 1450 ? '-37%' : '-29%',
    },
  },
  CongratulationsContainer: {
    CongratsSpan: {
      fontSize: '1em',
      color: theme.palette.common[12],
    },
  },

  Wheel: {
    Amount: {
      color: theme.palette.common[2],
      textShadow: 'none',
      paddingLeft: 4,
      marginRight:
        windowWidth < 1400 && window.innerHeight < 800 ? '-310px' : window.innerHeight < 900 ? '-340px' : '-420px',
      fontSize:
        windowWidth < 1400 && window.innerHeight < 800 ? '2rem' : window.innerHeight < 900 ? '2.2rem' : '2.5rem',
      fontWeight: 600,
      width: '150px',
    },
  },
  BottomBar: {
    Divider: {
      height: '90%',
      alignSelf: 'flex-end',
      width: 3,
      position: 'relative',
      bottom: 0,
    },
    BottomBarBackground: {
      height: '5rem',
      backgroundImage: `url("${require(asset`images/Bottom_Bar_Assets/Web_Backing.png`)}")`,
      bottom: 0,
      alignItems: 'flex-end',
      justifyContent: 'center',
      backgroundPosition: 'center',
      zIndex: 420,
    },
    BottomBarContainer: {
      maxWidth: 1140,
      display: 'flex',
      width: '100vw',
      alignItems: 'flex-end',
    },
    VIPIcon: {
      height: '6em',
    },
    BarItemIcon: {
      height: '4.5em',
    },
    BarMissionsIcon: {
      height: '4.5em',
    },
    Notification: {
      backgroundImage: `linear-gradient(to top, ${theme.palette.secondary[23]}, ${theme.palette.secondary[7]})`,
      border: `solid 1px ${theme.palette.secondary[4]}`,
      boxShadow: `0px 3px 4px 0 ${theme.palette.common[28]}`,
      height: '2rem',
      justifyContent: 'center',
      margin: '0.5rem',
      position: 'absolute',
      right: 0,
      top: 0,
      width: '2rem',
      zIndex: 1,
      borderRadius: '50%',
      display: 'flex',
      fontSize: '1.25rem',
    },
    MissionsIconAnimation: {
      bottom: 20,
      left: 25,
      height: '3.5em',
      marginBottom: 10,
      width: '80%',
    },
    MissionsIconText: {
      height: '0.9em',
      marginTop: 25,
    },
    MissionsIcon: {
      height: '4.5em',
    },
  },
  StoreDownload: {
    Container: {
      backgroundColor: theme.palette.primary[28],
    },
  },
  RewardCenter: {
    RewardCenterMainContentHolder: {
      display: 'flex',
      flexWrap: 'nowrap',
      width: '100%',
      justifyContent: 'space-between',
      marginTop: '2em',
    },
  },
  CreditCardDetails: {
    CheckBoxBackgroundImage: {
      zIndex: 12,
      width: '100%',
      height: '100%',
    },
  },
  LobbyOverlay: {
    MainSceneContainer: {
      paddingTop: NavHeight,
    },
  },
  Start: {
    Logo: {
      marginTop: '6%',
    },
    MainContentContainer: {
      marginTop: 30,
    },
    BottomBarFirstLine: {
      marginTop: 0,
    },
  },
  MissionsProgress: {
    MissionIcon: {
      right: windowWidth < 1300 ? 'calc(50% - 320px)' : windowWidth < 1400 ? 'calc(50% - 340px)' : 'calc(50% - 335px)',
      top: 4,
      height: windowWidth < 1400 ? 48 : 58,
      width: windowWidth < 1400 ? 83 : 93,
    },
    MissionIconWithoutCard: {
      right: windowWidth < 1300 ? 'calc(50% - 360px)' : windowWidth < 1400 ? 'calc(50% - 380px)' : 'calc(50% - 385px)',
      top: 4,
      height: 58,
      width: 93,
    },
    BaseBar: {
      right: windowWidth < 1300 ? 'calc(50% - 454px)' : windowWidth < 1400 ? 'calc(50% - 474px)' : 'calc(50% - 509px)',
      top: 8,
      height: windowWidth < 1400 ? 44 : 48,
    },
    BaseBarWithoutCard: {
      right: windowWidth < 1300 ? 'calc(50% - 534px)' : windowWidth < 1400 ? 'calc(50% - 554px)' : 'calc(50% - 559px)',
      top: 8,
      height: 48,
    },
    FillBar: {
      right: windowWidth < 1300 ? 'calc(50% - 475px)' : windowWidth < 1400 ? 'calc(50% - 495px)' : 'calc(50% - 507px)',
      width: windowWidth < 1400 ? 180 : 200,
    },
    FillBarWithoutCard: {
      right: windowWidth < 1300 ? 'calc(50% - 532px)' : windowWidth < 1400 ? 'calc(50% - 552px)' : 'calc(50% - 557px)',
      width: 200,
    },
    TimeBar: {
      right: windowWidth < 1300 ? 'calc(50% - 437px)' : windowWidth < 1400 ? 'calc(50% - 457px)' : 'calc(50% - 482px)',
      top: windowWidth < 1400 ? 49 : 54,
      height: windowWidth < 1400 ? 25 : 32,
      width: windowWidth < 1400 ? 140 : 180,
    },
    TimeBarWithoutCard: {
      right: windowWidth < 1300 ? 'calc(50% - 507px)' : windowWidth < 1400 ? 'calc(50% - 527px)' : 'calc(50% - 532px)',
      top: 54,
      height: 32,
      width: 180,
    },
    CollectBar: {
      right: windowWidth < 1300 ? 'calc(50% - 458px)' : windowWidth < 1400 ? 'calc(50% - 478px)' : 'calc(50% - 508px)',
      height: windowWidth < 1400 ? 43 : 46,
      width: windowWidth < 1400 ? 187 : 230,
    },
    CollectBarWithoutCard: {
      right: windowWidth < 1300 ? 'calc(50% - 534px)' : windowWidth < 1400 ? 'calc(50% - 555px)' : 'calc(50% - 563px)',
      height: 46,
      width: 230,
    },
    TimeRemainingText: {
      right: windowWidth < 1300 ? 'calc(50% - 410px)' : windowWidth < 1400 ? 'calc(50% - 430px)' : 'calc(50% - 450px)',
      fontSize: windowWidth < 1400 ? 16 : 20,
      top: windowWidth < 1400 ? 48 : 53,
    },
    TimeRemainingTextWithoutCard: {
      right: windowWidth < 1300 ? 'calc(50% - 475px)' : windowWidth < 1400 ? 'calc(50% - 495px)' : 'calc(50% - 500px)',
    },
    TextProgress: {
      left: windowWidth < 1400 ? 50 : 55,
      top: windowWidth < 1400 ? '-40%' : '-2%',
    },
    TextProgressWithoutCard: {
      left: 60,
      top: '-2%',
    },
    FillProgress: {
      marginTop: '-17px',
      marginLeft: '-16px',
      zIndex: 4,
    },
    FillProgressWithoutCard: {
      marginTop: '-17px',
      marginLeft: '-16px',
      zIndex: 4,
    },
    FillEnd: {
      marginTop: '-17px',
      marginLeft: '-1px',
      width: '13px',
      zIndex: 4,
    },
    FillEndWithoutCard: {
      marginTop: '-17px',
      marginLeft: '-1px',
      width: '13px',
      zIndex: 4,
    },
    ProgressAnimation: {
      width: windowWidth < 1400 ? '100%' : '110%',
      height: '9.5rem',
      left: '-9%',
      bottom: windowWidth < 1400 ? '-160%' : '-75%',
      zIndex: 5,
    },
    ProgressAnimationWithoutCard: {
      width: '110%',
      height: '9.5rem',
      left: '-9%',
      bottom: '-75%',
      zIndex: 5,
    },
  },
  Account: {
    Label: {
      fontWeight: '700 !important',
    },
  },
  SignUp: {
    ErrorMessage: {
      color: 'red',
    },
  },
  GameTile: {
    LivePanelItem: {
      height: '50%',
      width: '25%',
    },
  },
  Chest: {
    ChestAnimation: {
      height: 116.78,
      width: 115,
    },
    ChestAnimationEnd: {
      height: 116.78,
      width: 115,
    },
  },
  NotificationModal: {
    HeaderContainer: {
      height: '14%',
      left: 0,
      objectFit: 'contain',
      top: 0,
      width: '100%',
      zIndex: 11,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
  },
};

export default defaultTheme;

